import { apiSlice } from "app/api/apiSlice";

export const cryptoApiSlice = apiSlice.injectEndpoints({
  endpoints: builder => ({
    tagTypes: ["cryptos"],
    getCryptoSupply: builder.query({
      query: () => ({
        url: "/student/crypto",
      }),
      providesTags: ['crypto'],
    })
  }),
  overrideExisting: true,
})

export const {
  useGetCryptoSupplyQuery,
} = cryptoApiSlice